export enum AppRoutes {
    Start = 'start',
    Courier = 'courier',
    Call = 'call',
}